import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import IconButton from 'components/common/IconButton';
import ActionButton from 'components/common/ActionButton';
import { numberFormatter } from 'helpers/utils';
import {
  setDevelopPlantingSite,
  setPlantingSiteFocus
} from 'reducers/livingCarbonGrantReducer';

const BulAction = ({ onDrawPlantingSite }) => {
  return (
    <>
      <Row className="flex-between-center mb-3">
        <Col sm="auto" className="ms-auto text-end ps-0">
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            transform="shrink-3"
            className="me-2"
            onClick={() => onDrawPlantingSite(1)}
          >
            <span className="d-none d-sm-inline-block ms-1">New</span>
          </IconButton>
        </Col>
      </Row>
    </>
  );
};

BulAction.propTypes = {
  onDrawPlantingSite: PropTypes.func
};

const PlantingSiteTable = ({ onDrawPlantingSite }) => {
  const { plantingSites } = useSelector(state => state.livingCarbonGrant);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const handleLandParcelCenter = value => {
    dispatch(setPlantingSiteFocus(value.original.id));
  };

  const handleDevelopPlantingSite = value => {
    onDrawPlantingSite(6);
    dispatch(setDevelopPlantingSite(value.original.id));
    dispatch(setPlantingSiteFocus(value.original.id)); // focus to the selected planting site too
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Name',
      meta: {
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'area',
      header: 'Est. Area (ha)',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { area } = original;
        return numberFormatter(area, 2);
      }
    },
    {
      accessorKey: 'actions',
      header: 'Actions',
      cell: ({ row: { original } }) => {
        return (
          <>
            <ActionButton
              icon="arrows-to-dot"
              title="Center"
              variant="action"
              className="p-0 me-2"
              onClick={() => handleLandParcelCenter({ original })}
            />
            <ActionButton
              icon="edit"
              title="Edit"
              variant="action"
              className="p-0 me-2"
              onClick={() => handleDevelopPlantingSite({ original })}
            >
              Edit
            </ActionButton>
            <ActionButton
              icon="trash-alt"
              title="Delete"
              variant="action"
              className="p-0"
              onClick={() => console.log('Delete row ', original)}
            >
              Delete
            </ActionButton>
          </>
        );
      }
    }
  ];

  useEffect(() => {
    setData(plantingSites);
  }, [plantingSites]);

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    selection: false,
    pagination: true,
    perPage: 5,
    selectionColumnWidth: 30
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <BulAction onDrawPlantingSite={onDrawPlantingSite} />
        <AdvanceTable
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            striped: true,
            className: 'fs-10 mb-0 overflow-hidden'
          }}
        />
      </AdvanceTableProvider>
    </>
  );
};

PlantingSiteTable.propTypes = {
  onDrawPlantingSite: PropTypes.func
};

export default PlantingSiteTable;
